export default "__VITE_ASSET__830e7f8c__"